import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import Swal from "sweetalert2";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CustomerSupportMenu from "./menu/customer-supoort-menu";
import ActionDelete from "components/buttons/actionDelete";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import SafeField from "helpers/SafeField";
class customerSupport extends Component {
    constructor(props) {
        super(props)
        this.state = {
                industry : [],
                services:[]
        }

    }
     fetchIndustry() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("userId"),
        };
        axios
          .get(`${API_URL}ServiceType/allforagent`, { headers, params })
          .then((response) => {
            this.setState({ industry: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
       
 fetchProfessionalService() {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
        const params = {
          agentId: localStorage.getItem("userId"),
        };
        axios
          .get(`${API_URL}ProfessionalService/allagentprofessionalservices`, { headers, params })
          .then((response) => {
            this.setState({ services: response.data, loading: false });
          })
          .catch((error) => {
            this.setState({ error: error.message, loading: false });
          });
      }
        componentDidMount() {
            this.fetchIndustry();
            this.fetchProfessionalService();
        }
handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
        const payload= {
                agentId: parseInt(values.agentId),
                serviceType: parseInt(values.serviceType),
                organizationName: values.organizationName,
                organizationWebsite: values.organizationWebsite,
                contactName: values.contactName,
                email: values.email,
                mobile: values.mobile,
                office: values.office,
                isActive: true
        }
        toast.loading('Please wait...')
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const response = await axios.post(
        `${API_URL}ProfessionalService`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.dismiss();
        toast.success('Saved successfully.')
         this.fetchProfessionalService();
        resetForm();
      }else{
        toast.dismiss();
        toast.warn(response.data.validationErrors[0] || 'some issue please try after some time')
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitting(false);
    }
  };
  handleDelete = (serviceId) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won’t be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
  }).then((result) => {
    if (result.isConfirmed) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;

      axios
        .delete(`${API_URL}ProfessionalService/${serviceId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          Swal.fire("Deleted!", "Deleted successfully", "success");
          this.setState((prevState) => ({
            services: prevState.services.filter((s) => s.id !== serviceId),
          }));
        })
        .catch(() => {
          Swal.fire("Error!", "Something went wrong.", "error");
        });
    }
  });
};

    render() {
        const { industry, services} = this.state;
        return (
            <React.Fragment>
                   <ToastContainer autoClose={2000} />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Setting")}
                                    breadcrumbItem={this.props.t("Customer Support")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <CustomerSupportMenu />
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{

                                        agentId: localStorage.getItem('userId'),
                                        serviceType: '',
                                        organizationName:'',
                                        organizationWebsite:'',
                                        contactName:'',
                                        email:'',
                                        office:'',





                                    }}
                                   validationSchema={Yup.object().shape({
                                        serviceType: Yup.string()
                                            .required("This is required"),

                                        contactName: Yup.string()
                                            .required("This is required"),

                                        email: Yup.string()
                                            .email("Invalid email address")
                                            .required("This is required"),

                                        })}

                                    onSubmit={this.handleSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">Add new</h5>

                                                    <Row>
                                                        <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="serviceType">
                                                                    {this.props.t("Industry *")}
                                                                </Label>
                                                                <SafeField as="select" name="serviceType"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.serviceType && touched.serviceType
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    onChange={handleChange}>
                                                                    
                                                                    <option value="">Select</option>
                                                                   {industry.map((ind, index) => (
                                                                        <option key={index} value={ind.id}>
                                                                            {ind.serviceTypeTitle}
                                                                        </option>
                                                                        ))}
                                                                   
                                                                </SafeField>
                                                                <ErrorMessage
                                                                    name="serviceType"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="organizationName">
                                                                    Business name
                                                                </Label>
                                                                <SafeField
                                                                    name="organizationName"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.organizationName && touched.organizationName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="organizationName"
                                                                />
                                                                <ErrorMessage
                                                                    name="organizationName"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                     <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="organizationWebsite">
                                                                    Website
                                                                </Label>
                                                                <SafeField
                                                                    name="organizationWebsite"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.organizationWebsite && touched.organizationWebsite
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="organizationWebsite"
                                                                />
                                                                <ErrorMessage
                                                                    name="organizationWebsite"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                          <PhoneInputField
                                                            label="Office phone"
                                                            name="office"
                                                            value={values.office}
                                                            setFieldValue={setFieldValue}
                                                            error={errors.office}
                                                            touched={touched.office}
                                                            country="ca"
                                                            required={false}
                                                            />
                                                         
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="email">
                                                                    Email *
                                                                </Label>
                                                                <SafeField
                                                                    name="email"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.email && touched.email
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="email"
                                                                />
                                                                <ErrorMessage
                                                                    name="email"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                         <Col sm="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="contactName">
                                                                   Contact name *
                                                                </Label>
                                                                <SafeField
                                                                    name="contactName"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.contactName && touched.contactName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="contactName"
                                                                />
                                                                <ErrorMessage
                                                                    name="contactName"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                         <PhoneInputField
                                                            label="Mobile"
                                                            name="mobile"
                                                            value={values.mobile}
                                                            setFieldValue={setFieldValue}
                                                            error={errors.mobile}
                                                            touched={touched.mobile}
                                                            country="ca"
                                                            required={false}
                                                            />
                                                         
                                                        </Col>
                                                        <Col sm="9">


                                                        </Col>
                                                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md float-left mt-27">Submit</button></div>
                                                    </Row>

                                                    <h5></h5>
                                                                     

                                                </CardBody>





                                            </Card>


  <Card>
                        <CardBody>
                          <h5 className="card-title"></h5>
                          <div className="table-responsive">
                            <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                              <thead className="">
                                <tr>
                                  <th>Business</th>
                                  <th>Industry</th>


                                  <th>Contact</th>
                                   <th>Email</th>
                                   <th></th>                                 

                                </tr>
                              </thead>
                              <tbody>
                               {services.map((service, index) => (
                                  <tr key={index}>
                                    <th>{service.organizationName}</th>
                                    <td>{this.state.industry.find(opt => opt.id === service.serviceType)?.serviceTypeTitle || ""}</td>
                                    <td>{service.contactName}</td>
                                    <td>{service?.primaryContact?.email}</td>
                                    <td>
                                   
                                     <ActionDelete onClick={() => this.handleDelete(service.id)} />
                                     

                                    </td>
                                  </tr>
                               ))}
                              </tbody>
                            </table>
                          </div>
                        </CardBody>
                      </Card>






                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>

                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
customerSupport.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,


}
const mapStateToProps = () => (
    {



    })
const mapDispatchToProps = dispatch => ({


});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(customerSupport))
